<template>
    <div class="map-container">
        <div class="map" ref="map">
            <div class="table-of-contents table-of-contents--desktop table-of-contents--map-page">
                <router-link :to="`/chapters/${$index + 1}`" class="table-of-contents__item" :key="$index" v-for="(chapter, $index) in chapters">{{chapter}}</router-link>
            </div>
            <div class="map__inner">
                <div @click="goBack()" class="map__back">
                    <svg class="map__back__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.2 26" style="enable-background:new 0 0 110.2 26;" xml:space="preserve">
                        <path d="M45.7,21.1c-5.3-2-10.5-3.9-15.8-5.9c25.4-0.6,50.8-1.2,76.2-1.8c1.2,0,0.8-4.4-0.6-4.4 C78,9.6,50.4,10.3,22.9,10.9c5.5-1.9,11-3.8,16.5-5.7c1.4-0.5,0.5-4.8-0.6-4.4L7,11.3c-1,0.3-0.9,3.1,0,4.1C7.1,15.7,7.3,16,7.6,16"></path>
                    </svg>
                    <div class="map__back__text">
                        Вернуться
                    </div>
                </div>
                <div class="map__headline">
                    Карта
                </div>
                <div class="map__picture-container">
                    <div class="special-project">Спецпроект</div>
                    <div ref="container"  class="map__picture-container__outer">
                        <div class="map__picture-container__inner"  :class="{'map__picture-container__inner--moved': pictureMoved}" :style="{left: picturePosition + 'px'}">
                            <img ref="picture" src="@/assets/map.png" class="map__picture"/>
                            <div @mouseenter="setHover('first')" @mouseleave="hovered.first = false" class="map__point map__point--1">
                                <div class="map__point__inner"></div>
                                <div class="map__point__el"></div>
                                <div class="map__point__lines-holder"></div>
                            </div>
                            <div @mouseenter="setHover('second')" @mouseleave="hovered.second = false" class="map__point map__point--2">
                                <div class="map__point__inner"></div>
                                <div class="map__point__el"></div>
                                <div class="map__point__lines-holder"></div>
                            </div>
                            <div @mouseenter="setHover('third')" @mouseleave="hovered.third = false" class="map__point map__point--3">
                                <div class="map__point__inner"></div>
                                <div class="map__point__el"></div>
                                <div class="map__point__lines-holder"></div>
                            </div>
                        </div>
                    </div>
                    <div @click="moveLeft()" class="map__button map__button--left" v-if="pictureMoved">
                        <img src="@/assets/map-arrow-left.png" class="map__button__arrow"/>
                    </div>
                    <div @click="moveRight()" class="map__button map__button--right" v-if="!pictureMoved">
                        <img src="@/assets/map-arrow-right.png" class="map__button__arrow"/>
                    </div>
                    <div class="map__people map__people--1" :class="{'map__people--visible': hovered.first}">
                        <div class="map__people__headline">Здесь живут</div>
                        <div class="map__people__list">
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/2/photo.png"/>
                                    <div class="person__name">Аркадий Митц</div>
                                    <div class="person__age">72 года</div>
                                    <div class="person__info">
                                        Коллекционер букинистических изданий, историк-медиевист
                                    </div>
                                </div>
                            </div>
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/5/photo.png"/>
                                    <div class="person__name">Илья Инкин</div>
                                    <div class="person__age">22 года</div>
                                    <div class="person__info">
                                        Студент архитектурного колледжа
                                    </div>
                                </div>
                            </div>
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/8/photo.png"/>
                                    <div class="person__name">Дэн Волобуев</div>
                                    <div class="person__age">15 лет</div>
                                    <div class="person__info">
                                        Учащийся лицея, начинающий скейтер
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="map__people map__people--2" :class="{'map__people--visible': hovered.second}">
                        <div class="map__people__headline">Здесь живут</div>
                        <div class="map__people__list">
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/4/photo.png"/>
                                    <div class="person__name">Тимур Касаткин</div>
                                    <div class="person__age">29 лет</div>
                                    <div class="person__info">
                                        Арт-директор рекламного агентства
                                    </div>
                                </div>
                            </div>
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/6/photo.png"/>
                                    <div class="person__name">Ангелина Кулик</div>
                                    <div class="person__age">26 лет</div>
                                    <div class="person__info">
                                        Администратор в корпусе Andante
                                    </div>
                                </div>
                            </div>
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/7/photo.png"/>
                                    <div class="person__name">Стас Гришин</div>
                                    <div class="person__age">26 лет</div>
                                    <div class="person__info">
                                        Фитнес-тренер
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="map__people map__people--3" :class="{'map__people--visible': hovered.third}">
                        <div class="map__people__headline">Здесь живут</div>
                        <div class="map__people__list">
                            <div class="person">
                                <div class="person__inner">
                                    <img class="person__photo" src="@/assets/illustrations/3/photo.png"/>
                                    <div class="person__name">Саша Рыженко</div>
                                    <div class="person__age">12 лет</div>
                                    <div class="person__info">
                                        Школьник
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="map__info">
                    <div class="map__info__text">Наполнение дворов зеленью многочисленных кленов, ясеней, сосен, вязов и даже ирги дополняет ощущение единения с природой.</div>
                    <div class="map__info__row map__info__row--fit">
                        <div class="map__info__headline">
                            MR FIT CLUB:
                        </div>
                        <div class="map__info__items">
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/1.png"/>
                                <span>тропа здоровья (один круг 500м)</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/2.png"/>
                                <span>баскетбольная площадка</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/3.png"/>
                                <span>воркаут</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/4.png"/>
                                <span>скейт парк</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/5.png"/>
                                <span>батутная площадка</span>
                            </div>
                        </div>
                    </div>
                    <div class="map__info__row map__info__row--green">
                        <div class="map__info__headline">
                            ОЗЕЛЕНЕНИЕ:
                        </div>
                        <div class="map__info__items">
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/11.png"/>
                                <span>ива белая плакучая</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/12.png"/>
                                <span>липа ломкая</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/13.png"/>
                                <span>клен остролистный</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/14.png"/>
                                <span>клен красный</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/15.png"/>
                                <span>яблоня рудольф</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/16.png"/>
                                <span>ирга</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/17.png"/>
                                <span>липа ломкая</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/18.png"/>
                                <span>сосна</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/19.png"/>
                                <span>ель</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/20.png"/>
                                <span>можжевельник виргинский</span>
                            </div>
                        </div>
                    </div>
                    <div class="map__info__row map__info__row--children">
                        <div class="map__info__headline">
                            ДЕТСКИЕ ЗОНЫ:
                        </div>
                        <div class="map__info__items">
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/6.png"/>
                                <span>детский сад</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/7.png"/>
                                <span>площадки от 0 до 3 лет</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/8.png"/>
                                <span>площадки от 3 до 5 лет</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/9.png"/>
                                <span>площадки 5+ лет</span>
                            </div>
                            <div class="map__info__item">
                                <img src="@/assets/map-icons/10.png"/>
                                <span>школа</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<style lang="stylus">
    @import "~@/assets/styles/sizes.styl";
    .page-map
        .overlay
            display none
    .map
        width 100vw
        height 100vh
        background url('../assets/overlay.jpg') 0 0
        background-size 100vw
        background-repeat repeat
        background-attachment fixed
        overflow hidden
        .special-project
            display none
        .page-map--scrollable &
            overflow scroll
            .special-project
                display block

        +mobile()
            min-height vw(1000, $mobile)
            height auto
            overflow visible
            .special-project
                display none!important
        &__back
            z-index 105
            cursor pointer
            position absolute
            left vw(32, $desktop)
            top vw(130, $desktop)
            font-size vw(14, $desktop)
            color #59544c
            display flex
            align-items center
            +mobile()
                font-size vw(12, $mobile)
                top vw(90, $mobile)
                left vw(20, $mobile)
            &__text
                margin-left vw(12, $desktop)

            svg
                fill #cb993f
                height vw(10, $desktop)
                +mobile()
                    height vw(6, $mobile)
        &__inner
            z-index 105
            width 100%
            height 100%
            position relative
            +mobile()
                z-index 103
        &__headline
            font-family Solena
            font-size vw(80, $desktop)
            text-align center
            padding-top vw(80, $desktop)
            padding-bottom vw(40, $desktop)
            +mobile()
                font-size vw(60, $mobile)
                padding-top vw(60, $mobile)
                padding-bottom vw(10, $mobile)
        &__button
            position absolute
            top "calc(50% - %s)" % vw(25, $desktop)
            width vw(50, $desktop)
            height vw(50, $desktop)
            background #cb993f
            box-shadow .5em .5em 2.5em rgba(0, 0, 0, .25)
            fill #fff
            border-radius 50%
            cursor pointer
            display flex
            align-items center
            justify-content center
            +mobile()
                z-index 1000
                top vw(185, $mobile)
                width vw(50, $mobile)
                height vw(50, $mobile)
            &__arrow
                width vw(24, $desktop)
                +mobile()
                    width vw(24, $mobile)
            &--left
                left vw(-25, $desktop)
                justify-content flex-end
                +mobile()
                    justify-content center
                    left vw(-5, $mobile)
            &--right
                left "calc(60vw + %s)" % vw(35, $desktop)
                +mobile()
                    justify-content center
                    left auto
                    right vw(-5, $mobile)
        &__picture-container
            position relative
            width 65vw
            .page-map--scrollable &
                padding-bottom vw(40, $desktop)
            +mobile()
                width 100%
            &__outer
                width 100%
                overflow hidden
            &__inner
                position relative
                transition all .75s

        &__info
            width vw(280, $desktop)
            position absolute
            top vw(120, $desktop)
            right vw(30, $desktop)
            display flex
            flex-wrap wrap
            +mobile()
                top vw(530, $mobile)
                width "calc(100% - %s)" % vw(240, $mobile)
            &__headline
                font-size vw(12, $desktop)
                color #cb993f
                font-weight bold
                margin-bottom vw(10, $desktop)
                +mobile()
                    font-size vw(12, $mobile)
            &__text
                line-height vw(15, $desktop)
                width 45%
                margin-left 5%
                font-size vw(9, $desktop)
                position relative
                top vw(45, $desktop)
                +mobile()
                    line-height vw(15, $mobile)
                    font-size vw(12, $mobile)
                    position absolute
                    left vw(-220, $mobile)
                    width vw(200, $mobile)
                    top 0
                    margin 0
            &__row
                width 45%
                margin-left 5%
                +mobile()
                    width 100%
                    margin 0
            &__items
                margin-bottom vw(20, $desktop)
            &__item
                display flex
                align-items flex-start
                margin-bottom vw(5, $desktop)
                font-size vw(9, $desktop)
                +mobile()
                    font-size vw(12, $mobile)
                img
                    height vw(12, $desktop)
                    margin-right vw(5, $desktop)
                    +mobile()
                        margin-right vw(5, $mobile)
                        height vw(12, $mobile)

        &__picture
            position relative
            transition all .75s
            height vw(400, $desktop)
            +mobile()
                height vw(360, $mobile)
                /*
                left vw(-600, $mobile)
                */
        &__point
            position absolute
            width vw(28, $desktop)
            height vw(28, $desktop)
            box-shadow 0 vw(5, $desktop) vw(2.5, $desktop) rgba(0, 0, 0, .35)
            background #fff
            border-radius 50%
            display flex
            align-items center
            justify-content center
            cursor pointer
            +mobile()
                width vw(28, $mobile)
                height vw(28, $mobile)
            &--1
                right vw(10, $desktop)
                bottom vw(60, $desktop)
                +mobile()
                    position relative
                    right vw(-710, $mobile)
                    bottom vw(90, $mobile)
            &--2
                right vw(130, $desktop)
                top vw(120, $desktop)
                +mobile()
                    right vw(-235, $mobile)
                    top vw(110, $mobile)
            &--3
                left vw(360, $desktop)
                bottom vw(50, $desktop)
                +mobile()
                    left vw(310, $mobile)
                    bottom vw(70, $mobile)
            &__inner
                z-index 10
                position relative
                width vw(16, $desktop)
                height vw(16, $desktop)
                border vw(2, $desktop) solid #91661a
                border-radius 50%
                display flex
                align-items center
                justify-content center
                animation pulse 1s ease-out infinite
                +mobile()
                    width vw(16, $mobile)
                    height vw(16, $mobile)
                    border-width vw(1, $mobile)
            &__el
                transition all .35s
                opacity 1
                position absolute
                content ""
                display block
                width vw(16, $desktop)
                height vw(16, $desktop)
                top vw(4, $desktop)
                left vw(4, $desktop)
                border vw(2, $desktop) solid #91661a
                animation pulse 1s ease-out infinite
                animation-delay .3s
                border-radius 50%
                +mobile()
                    width vw(6, $mobile)
                    height vw(6, $mobile)
                    border-width vw(3, $mobile)
            &__lines-holder
                position relative
            &:hover &__inner
                border vw(2, $desktop) solid #91661a
            &:hover &__inner:before
                background #91661a
            &:hover &__lines-holder:after
                content ""
                display block
                position absolute
                background #91661a
                width vw(200, $desktop)
                left vw(17, $desktop)
                height 2px
                +mobile()
                    left vw(-150, $mobile)
                    width vw(150, $mobile)
            &--1:hover &__lines-holder:after
                +mobile()
                    background #91661a
                    content ""
                    display block
                    position absolute
                    width 2px
                    height vw(80, $mobile)
                    left vw(-150, $mobile)
            &--1:hover &__lines-holder:before
                +mobile()
                    background #91661a
                    content ""
                    display block
                    position absolute
                    width vw(130, $mobile)
                    height 2px
                    left vw(-150, $mobile)
            &--2:hover &__lines-holder:after
                top vw(230, $desktop)
                left vw(-10, $desktop)
                width vw(344, $desktop)
                +mobile()
                    top vw(-1, $mobile)
                    left vw(-50, $mobile)
                    width vw(30, $mobile)
            &--3:hover &__lines-holder:after
                width vw(700, $desktop)
                +mobile()
                    top vw(-1, $mobile)
                    left vw(-320, $mobile)
                    width vw(300, $mobile)
            &--2:hover &__lines-holder:before
                content ""
                display block
                position absolute
                width 2px
                left vw(-10, $desktop)
                background #91661a
                height vw(230, $desktop)
                +mobile()
                    height vw(260, $mobile)
                    left vw(-50, $mobile)
            &--3:hover &__lines-holder:before
                +mobile()
                    content ""
                    display block
                    position absolute
                    width 2px
                    left vw(-320, $mobile)
                    background #91661a
                    height vw(70, $mobile)
        &__people
            position absolute
            left "calc(100% - %s)" % vw(50, $desktop)
            bottom vw(-60, $desktop)
            z-index 99
            padding-left vw(10, $desktop)
            background url('../assets/overlay.jpg') 0 0
            background-size 100vw
            background-repeat repeat
            background-attachment fixed
            opacity 0
            &--3
                left "calc(100% - %s)" % vw(-10, $desktop)
                bottom vw(-50, $desktop)
            &--visible
                opacity 1
            +mobile()
                position initial
                width vw(220, $mobile)
                margin-top vw(80, $mobile)
                display none
                &--visible
                    display block
            &__headline
                font-style italic
                margin-bottom vw(10, $desktop)
                color #cb993f
                font-size vw(13, $desktop)
                +mobile()
                    margin-left vw(10, $mobile)
                    font-size vw(13, $mobile)
                    margin-bottom vw(10, $mobile)
            &__list
                display flex

                +mobile()
                    flex-wrap wrap
                    margin-left vw(15, $mobile)
                .person
                    position relative
                    margin-right vw(15, $desktop)
                    +mobile()
                        text-align left
                        margin 0
                        width 50%
                    &__photo
                        width vw(45, $desktop)
                        +mobile()
                            width vw(50, $mobile)!important
                    &__name
                        white-space nowrap
                        margin-top vw(5, $desktop)
                        font-size vw(13, $desktop)
                        +mobile()
                            white-space initial
                            font-size vw(12, $mobile)
                    &__age
                        font-size vw(12, $desktop)
                        +mobile()
                            font-size vw(12, $mobile)
                    &__info
                        font-size vw(11, $desktop)
                        line-height 1.5
                        +mobile()
                            font-size vw(11, $mobile)
    @keyframes pulse
        0%
            transform scale(.1,.1)
            opacity 0
        50%
            opacity 1
        100%
            transform scale(1.2,1.2)
            opacity 0

</style>
<script>
    export default {
        watch: {
            loaded(isLoaded) {
                if (isLoaded) {
                   this.checkHeight();
                   this.moveRight();
                   window.addEventListener('resize', this.checkHeight);
                }
            }
        },
        beforeDestroy() {
            document.getElementById('app').classList = "page-map";
            window.removeEventListener('resize', this.checkHeight);
        },
        mounted() {
            if (this.loaded) {
                this.$refs.picture.onload = () => {
                    this.moveRight(false);
                }

            }
        },
        methods: {
            setHover(name) {
                let hotspots = {
                    "first": "adagio",
                    "second": "andante",
                    "third": "vivo"
                };
                this.hovered[name] = true;
                this.$ga.event('internal','click', 'map_hotspot_' + hotspots[name]);
            },
            checkHeight() {
                if (window.outerWidth > 480) {
                    let rect = this.$refs.picture.getBoundingClientRect();
                    if (rect.bottom > window.innerHeight) {
                        document.getElementById('app').classList += " page-map--scrollable";
                    }
                }
            },
            goBack() {
                this.$ga.event('internal','click', 'map_back');
                if (this.$route.query.return) {
                    this.$router.push(this.$route.query.return+"?opened=1");
                } else {
                    this.$router.push('/chapters/1');
                }
            },
            moveLeft(sendGa=true) {
                if(sendGa)this.$ga.event('internal','click', 'map_move_left');
                this.picturePosition = window.outerWidth / 100 * 6;
                this.pictureMoved = false;
            },
            moveRight(sendGa=false) {
                if (sendGa) this.$ga.event('internal', 'click', 'map_move_right');
                let picture = this.$refs.picture;
                let container = this.$refs.container;
                let width = picture.offsetWidth;
                let containerWidth = container.offsetWidth;
                this.picturePosition = -1 * (width - containerWidth);
                this.pictureMoved = true;
            },
        },
        props: {
            loaded: {
                type: Boolean
            }
        },
        data() {
            return {
                pictureMoved: false,
                hovered: {
                    first: false,
                    second: false,
                    third: false,
                },
                picturePosition: 0,
                chapters: [
                    'I',
                    'II',
                    'III',
                    'IV',
                    'V',
                    'VI',
                    'VII',
                    'VIII',
                ]
            }
        }
    }
</script>